var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',[_c('keep-alive',{attrs:{"exclude":['inventoriesList', 'UsersList']}},[_c('router-view',{key:_vm.$route.fullPath})],1),_c('core-app-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }